/** @format */
import { Heading as HeadingComponent } from '@mpb-com/feather/components/atoms/heading';
import styled from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const MarketSelectorModalWrapper = styled.div`
    display: flex;
    flex-direction: column;

    max-height: 53rem;
    overflow: hidden;
`;

export const Heading = styled(HeadingComponent)`
    align-self: center;
    margin-bottom: var(--layout-spacing-12);
`;

export const Selected = styled.section`
    margin-bottom: var(--layout-spacing-12);

    p {
        ${theme.typography.body_small_highlight};
        margin-bottom: var(--layout-spacing-4);
    }
`;

export const Selectable = styled.section`
    overflow-y: scroll;
`;
